import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrderFulfillmentMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
  manual_amounts?: Types.InputMaybe<Array<Types.ContainerTypeAmountInput> | Types.ContainerTypeAmountInput>;
  timestamp?: Types.InputMaybe<Types.Scalars['String']>;
  container_station_ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
  asset_ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type UpdateOrderFulfillmentMutation = { __typename?: 'Mutation', updateOrderFulfillment: { __typename?: 'OrderFulfillment', id: string } };


export const UpdateOrderFulfillmentDocument = gql`
    mutation UpdateOrderFulfillment($order_fulfillment_id: ID!, $manual_amounts: [ContainerTypeAmountInput!], $timestamp: String, $container_station_ids: [ID!], $asset_ids: [ID!]) {
  updateOrderFulfillment(
    order_fulfillment_id: $order_fulfillment_id
    manual_amounts: $manual_amounts
    timestamp: $timestamp
    container_station_ids: $container_station_ids
    asset_ids: $asset_ids
  ) {
    id
  }
}
    `;
export type UpdateOrderFulfillmentMutationFn = Apollo.MutationFunction<UpdateOrderFulfillmentMutation, UpdateOrderFulfillmentMutationVariables>;

/**
 * __useUpdateOrderFulfillmentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderFulfillmentMutation, { data, loading, error }] = useUpdateOrderFulfillmentMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *      manual_amounts: // value for 'manual_amounts'
 *      timestamp: // value for 'timestamp'
 *      container_station_ids: // value for 'container_station_ids'
 *      asset_ids: // value for 'asset_ids'
 *   },
 * });
 */
export function useUpdateOrderFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderFulfillmentMutation, UpdateOrderFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderFulfillmentMutation, UpdateOrderFulfillmentMutationVariables>(UpdateOrderFulfillmentDocument, options);
      }
export type UpdateOrderFulfillmentMutationHookResult = ReturnType<typeof useUpdateOrderFulfillmentMutation>;
export type UpdateOrderFulfillmentMutationResult = Apollo.MutationResult<UpdateOrderFulfillmentMutation>;
export type UpdateOrderFulfillmentMutationOptions = Apollo.BaseMutationOptions<UpdateOrderFulfillmentMutation, UpdateOrderFulfillmentMutationVariables>;